import React from "react";
import { useMediaQuery } from "react-responsive";
import classNames from "classnames";

import { Button, ProjectCard } from "../../components";
import ProjectSlider from "../../pages/projects/ProjectSlider";

import styles from "./ProjectExamples.module.scss";

const ProjectExamples = ({
  projects,
  title = "Наши проекты",
  isSmallTitleMargin,
}) => {
  const isDesktop = useMediaQuery({ query: "(min-width: 750px)" });

  return (
    <div className={styles.ProjectExamples}>
      <h2
        className={classNames(
          "h2-title title-with-mrg title-with-mrg_small",
          isSmallTitleMargin && "title-with-mrg_small"
        )}
      >
        {title}
      </h2>

      <div className={isDesktop && styles.ProjectsList}>
        {isDesktop ? (
          projects.map((item) => {
            return <ProjectCard item={item} key={item.id} />;
          })
        ) : (
          <ProjectSlider projects={projects} totalCount={3} />
        )}
      </div>

      <div className={styles.AlignCenter}>
        <Button className={styles.Button} to="/projects">
          Больше проектов
        </Button>
      </div>
    </div>
  );
};

export default ProjectExamples;
